import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
// import PelariHandal from "../../../assets/images/pelari-handal.png";
import API_URL from "../../../config/constant";

export default function Podium() {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);

    useEffect(() => {
        const fetchPodiumData = async () => {
            try {
                const response = await fetch(`${API_URL}/home?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.podium.data.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res.podium);
            } catch (error) {
                setData(t("home.podium", { returnObjects: true }));
            }
        };

        fetchPodiumData();
    }, [t, locale]);

    return (
        <>
            <div className="w-full bg-podiumMobile md:bg-podium relative bg-top bg-cover bg-no-repeat md:min-h-screen flex max-md:flex-wrap items-center h-[125vh] md:h-[1920px] max-md:overflow-hidden">
                <div className="container mx-auto font-ronzino text-white max-md:pt-0">
                    <div className={`md:text-left font-wantCoffee ${locale === 'en' ? 'bg-textBgPodiumEn' : 'bg-textBgPodiumId'} bg-no-repeat bg-left min-h-[180px] md:min-h-[240px] ${locale === 'en' ? 'bg-[length:400px_auto] md:bg-[length:490px_auto]' : 'bg-[length:380px_auto]'}`}>
                        <p className={`text-6xl md:text-[5rem] relative top-8 md:top-10 leading-none text-secondary ${locale === 'en' ? 'left-12 md:left-14' : 'left-10'}`}>{data?.title}</p>
                        <p className={`text-6xl md:text-[5rem] relative top-8 md:top-10 leading-none text-white ${locale === 'en' ? 'left-12 md:left-14' : 'left-10'}`} style={{ letterSpacing: '3px' }}>{data?.subTitle}</p>
                    </div>
                    <div className="flex items-center justify-center md:mt-12">
                        <div className="flex flex-col md:flex-row gap-x-0 justify-center items-center mx-4 gap-y-0 md:gap-y-4 relative md:-top-24 md:left-36">
                            {data?.data.map((item, index) => (
                                <div className={`basis-full flex justify-center items-center flex-wrap bg-textBgPodiumNational bg-no-repeat bg-[length:300px_300px] md:bg-[length:480px_480px] bg-top min-h-[300px] md:min-h-[480px] min-w-[300px] md:min-w-[480px]`} key={index}>
                                    <div className="basis-full max-w-[180px] md:max-w-[260px]">
                                        <div className="text-center w-full">
                                            <p className="text-lg md:text-2xl text-primary font-roboto font-bold px-4 lg:px-8 py-2 border-b-2 border-mutedGrey">{item.title}</p>
                                        </div>
                                        <div className="py-2 md:py-6 md:px-4 text-center rounded-b-lg font-semibold font-ronzino text-black text-md">
                                            <p>{item.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex items-center justify-center">
                        <div className="flex flex-row gap-x-0 justify-center items-center mx-0 md:mx-4 gap-y-4 relative bg-textBgTotalPrize bg-no-repeat bg-[length:100vw_auto] min-h-[240px] min-w-[100vw] md:bg-[length:1254px_auto] bg-top md:min-h-[695px] md:min-w-[1280px] px-10 md:px-24">
                            <div className="flex flex-row w-full md:mx-12">
                                <div className={`basis-1/4 flex justify-start items-center flex-wrap bg-textBgTotalPrizeTitle bg-no-repeat bg-[length:150px_auto] md:bg-[length:425px_auto] bg-bottom min-w-[150px] md:min-w-[425px] min-h-[100px] md:min-h-[352px]`}>
                                    <div className="basis-full relative left-2 md:left-8 text-left max-md:-top-2">
                                        <p className="text-4xl md:text-[7rem] leading-none text-primary font-wantCoffee font-bold px-4 lg:px-8 md:py-2">{data?.cardTitle}</p>
                                        <p className="text-4xl md:text-[7rem] leading-none text-secondary font-wantCoffee font-bold px-4 lg:px-8 md:py-2">{data?.cardSubTitle}</p>
                                    </div>
                                </div>
                                <div className={`basis-3/4 flex justify-center items-center flex-wrap`}>
                                    <div className="basis-full flex flex-col">
                                        <p className="text-5xl md:text-7xl md:text-[9rem] leading-none text-white font-roboto font-semibold px-4 lg:px-8 py-2 text-center">{data?.prizeAmount}</p>
                                        <p className="px-2 py-1 md:px-4 md:py-2 bg-secondary text-white font-roboto font-bold w-[120px] md:w-[360px] mx-auto text-center tracking-widest text-xs md:text-base">{data?.prizeDesc}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
    // 1673 x 927 470

}
